import React from 'react';
import { usePrefs } from 'wsm-common-data';
import PaymentSelector from './PaymentSelector';
import SpecialsDisplay from './SpecialsDisplay';
import StepCtas from './StepCtas';

const PaymentSelectorView = () => {
	const { enableIncentives, showCTAs } = usePrefs();

	return (
		<>
			<PaymentSelector key="track-my-offer-payment-selector" />
			{enableIncentives === 'true' && (
				<SpecialsDisplay key="track-my-offer-specials-display" />
			)}
			{showCTAs === 'true' && <StepCtas key="track-my-offer-ctas" />}
		</>
	);
};

export default PaymentSelectorView;
